import React, { Component, ReactNode } from 'react';
import { Button } from '@mui/material';
import Header from "../../../components/commonComponents/header/header";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onReset?: () => void;           // Optional custom reset
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: undefined });
    this.props.onReset?.();
  };

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <DefaultFallback onReset={this.handleReset} />;
    }

    return this.props.children;
  }
}

const DefaultFallback: React.FC<{ onReset: () => void }> = ({ onReset }) => {
  return (
    <>
    <Header />
    <div style={{
      padding: '60px 20px',
      textAlign: 'center',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <h1>Something went wrong</h1>
      <p style={{ marginBottom: '30px', color: '#666' }}>
        An unexpected error occurred.
      </p>

      <Button
        variant="text"
        sx={{ mt: 2 }}
        onClick={() => window.location.reload()}
      >
        Reload Page
      </Button>
    </div>
    </>
  );
};

export default ErrorBoundary;